<template>
  <envelope preview :skin="order.skin" :aspect-ratio="5/7">
    <template v-slot:default="{ w }">
      <div
        v-if="order.design_id == nullCoverDesignId"
        class="overflow-visible d-flex align-center"
        style="aspect-ratio: 5 / 7;"
      >
        <v-card class="fill-width" tile dark>
          <v-img :aspect-ratio="16 / 9" :src="groupVideoBlob.group_video.poster" />
        </v-card>
      </div>
      <v-card v-else tile class="overflow-hidden">
        <card-preview :mode="mode || 'edit'" :card="order" :width="w" :is-card-owner="true" />
      </v-card>
      <div
        v-if="order.type == 'INVITATION'"
        class="absolute"
        style="
          width: 120%;
          height: 120%;
          bottom: -5%;
          right: 0;
          transform: rotate(5deg) scale(.5);
          transform-origin: bottom right;
        "
      >
        <v-card class="absolute-fill overflow-hidden px-4" tile elevation="20">
          <div class="py-3 title text-center">RSVP</div>
          <v-divider class="mb-n3" />
          <form-rsvp
            v-if="order.event?.form"
            style="user-select: none; pointer-events: none;"
            :form="order.event.form"
            :response="{}"
            :disabled="true"
          />
        </v-card>
      </div>
    </template>
  </envelope>
</template>


<script>
import CardPreview from '@/components/CardPreview.vue';
import Envelope from '@/components/Envelope.vue';
import FormRsvp from '@/components/FormRsvp.vue';
import { publicDesign } from '@/mixins/public-design.js';
import { findGroupVideoBlob } from '@/utils/group-video.js';


export default {
  name: 'envelope-order-preview',

  components: { CardPreview, Envelope, FormRsvp },

  mixins: [ publicDesign ],

  props: [ 'mode', 'order' ],

  computed: {
    groupVideoBlob() {
      return findGroupVideoBlob(this.order);
    }
  }
}
</script>
